"use client";

import { useSiteFlavor } from "@/components/layout/site-flavor-provider";
import { LegalDocument } from "@/components/legal/legal-document";
import { GRIGORETS_TERMS_SECTIONS, TERMS_SECTIONS } from "@/components/legal/sections";

export function TermsPage() {
  const { flavor, brand } = useSiteFlavor();

  return <LegalDocument namespace="terms" sections={brand.legalProfile === "grigorets" ? GRIGORETS_TERMS_SECTIONS : TERMS_SECTIONS[flavor]} />;
}
